import { render } from "./CompetitionList.vue?vue&type=template&id=ac83a2d2&scoped=true"
import script from "./CompetitionList.vue?vue&type=script&lang=js"
export * from "./CompetitionList.vue?vue&type=script&lang=js"

import "./CompetitionList.vue?vue&type=style&index=0&id=ac83a2d2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac83a2d2"]])

export default __exports__